import React, { useState } from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, IExtractedProps } from "Common/utils/commonTypes";

export const ExpandWithTitle: React.FC<IComponentProps> = props => {
    const [expanded, setExpanded] = useState<boolean>(false);
    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["text", "expandedText", "anchorId"]
    });

    const expandedClass: string = expanded ? "tq-expanded" : "";

    return (
        <>
            <div className="tq-line-separator un-source-info-line" />
            <div
                className="tq-accordion un-source-info-accordion un-source-info-accordion-blue"
                id={dataProps.anchorId ? dataProps.anchorId : null}
            >
                <div className={"tq-section tq-expandable " + expandedClass}>
                    <div className="tq-section-header" onClick={() => setExpanded(!expanded)}>
                        <div className="tq-splitbox">
                            <div className="tq-splitbox-primary">
                                <h3
                                    className="tq-title tq-bold tq-neutral-color-1"
                                    dangerouslySetInnerHTML={{
                                        __html: xssFilter.process(dataProps.text)
                                    }}
                                    data-hyperlinks-container={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="tq-section-content">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: xssFilter.process(dataProps.expandedText)
                            }}
                            data-hyperlinks-container={true}
                        />
                    </div>
                </div>
            </div>
            <div className="tq-line-separator un-source-info-line" />
        </>
    );
};

export default webui.connectComponent()(ExpandWithTitle);
